import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20c8 0 10 -16 18 -16","key":"svg-0"}]]

const IconEaseInOut = createReactComponent('outline', 'ease-in-out', 'EaseInOut', __iconNode);

export default IconEaseInOut;